// extracted by mini-css-extract-plugin
module.exports = {"container":"audits_container__WHGGZ","audits":"audits_audits__hss6b","auditsItem":"audits_auditsItem__oudEO"};